import React from "react";
import { PieChart, Pie } from "recharts";

let arr = []

const calculateValue = (value) => {
  arr = [{ name: value.data.name, value: parseInt(value.data.contribution), fill: value.colorFill }, { name: value.data.name, value: (100 - parseInt(value.data.contribution)), fill: value.colorVoid }]
}
const calculateValue_SD = (value) => {
  arr = [
    {
      name: value.data.RegionName,
      value: Math.abs(value.data.Growth),
      fill: value.colorFill,
    },
    {
      name: value.data.RegionName,
      value: 100 - Math.abs(value.data.Growth),
      fill: value.colorVoid,
    },
  ];
};

const MyPieChart = (props) => {
  props.type && props.type === "PD" && calculateValue(props);          // Value conversion for PD
  props.type && props.type === "SD" && calculateValue_SD(props);       // Value conversion for SD
  return (
    <PieChart width={130} height={130}>
      <Pie
        data={arr}
        cx={60}
        cy={60}
        innerRadius={"50%"}
        outerRadius={"100%"}
        paddingAngle={4}
        startAngle={90}
        endAngle={-270}
        fill={arr.fill}
      />
    </PieChart>
  );
};

export default MyPieChart;
